module.exports = __webpack_public_path__ + "static/media/Chris.a5b21831.png";